import {
	Grid,
	Typography,
	Box,
	TextField,
	InputAdornment,
	Card,
} from '@mui/material';

import { useEffect, useState, useRef } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import { useNavigate, useParams, useLocation } from 'react-router-dom';

import { addRelationshipMapping } from 'common/api';
import { circleDeleteWhiteIcon } from 'common/assets/images';
import { ReactComponent as Regenerate } from 'common/assets/images/ai-generate.svg';
import { ReactComponent as AILoader } from 'common/assets/images/loader.svg';
import { ReactComponent as Plus } from 'common/assets/images/Plus.svg';
import { ReactComponent as SearchOutlined } from 'common/assets/images/search-outline.svg';
import { ReactComponent as Sort } from 'common/assets/images/sort-icon.svg';
import AccordionComp from 'common/components/Accordion/AccordionComp';
import AIFeedback from 'common/components/AIFeedback/AIFeedback';
import ButtonComp from 'common/components/Button/ButtonComp';
import CardTable from 'common/components/CardTable/CardTable';
import { Loader } from 'common/components/Loader/Loader';
import ModalEle from 'common/components/Modal/ModalEle';
import SideDrawer from 'common/components/SideDrawer/SideDrawer';
import {
	FEEDBACK_OBJECT_TYPE,
	MODULES,
	MODULE_NAME,
	TABLE_VIEW_PAGE_SIZE,
	TASKTYPE,
} from 'common/constants';
import { AI_SIMULATION_GENAI_DISCLAIMER } from 'common/constants/AISimulationConstants';
import {
	STATUS_UPDATE_TYPE,
	PROGRESS_BAR_ELEMENTS,
} from 'common/constants/CitationDetails';
import { HTTP_STATUS_CODES } from 'common/constants/HttpStatusConstants';
import { AI_CARD_CONTENT } from 'common/constants/RegulationInventoryConstants';
import { rrcpDashboardRoutes } from 'common/constants/rrcp-dashboard-routes';
import { ENTITY_STATUS, ENTITY_TYPE } from 'common/constants/TaxonomyConstants';
import {
	REG_INV_APPROVAL_ERROR_MSG,
	REG_INV_SUBMIT_ERROR_MSG,
} from 'common/constants/TextContent';
import { RootState } from 'common/store/AppStore';
import { setToastMessage } from 'common/store/reducer/commonReducer';
import { setRegInvSummaryRegenerated } from 'common/store/reducer/regulationInventoryReducer';
import {
	generateToastMessage,
	toSentenceCase,
	urlWithTenant,
	removeHTMLTags,
} from 'common/utils/utilFunctions';

import useTableQuery from 'hooks/useTableQuery';

import AddMappingModal from 'features/RiskProfile/Taxonomy/RelationMapping/AddMappingModal/AddMappingModal';
import AIMappingCard from 'features/RiskProfile/Taxonomy/RelationMapping/AIMappingCard';
import DetailedMappingLayout from 'features/RiskProfile/Taxonomy/RelationMapping/MappingDetail/DetailedMappingLayout';
import {
	fetchAllTabsData,
	getChildEntityOptionsData,
} from 'features/RiskProfile/Taxonomy/TaxonomyUtils';

import {
	getMappingDetailsData,
	getRegInvRelationshipData,
	postInventoryMappingStatus,
	putInventoryMappingStatus,
	getMappingStatusCount,
	postMappingGenerate,
} from '../api';
import {
	IBusinessUnitMappingEntity,
	IUpdateBusinessUnitMappingEntity,
	IMappingEnity,
	IGetRegInvRelationshipRequestParams,
} from '../api/type-def';
import RegenerateSummaryDailog from '../Components/RegenerateSummaryDailogue/RegenerateSummaryDailogue';
import RegInventorySummaryAndMapping, {
	IRegulationInventoryMappingElements,
} from '../Components/SummaryAndMappingComponents/SummaryAndMapping';
import { fetchToastMsgData } from '../RegInventoryUtils';

import styles from './RegulationInventoryMappingDetail.module.scss';

const { addNewButtonColor, borderColor, searchBoxColor } = styles;

const { OK, CREATED, INTERNAL_SERVER_ERROR } = HTTP_STATUS_CODES;

const { NO_DATA_SEARCH, PROCESSING, NO_DATA } = AI_CARD_CONTENT;

const { REQUIREMENT_INVENTORY } = MODULES;

const { RELATIONSHIP_MAPPING } = FEEDBACK_OBJECT_TYPE;

const { WORKFLOW } = TASKTYPE;

const { TABLE_SIZE_12 } = TABLE_VIEW_PAGE_SIZE;

const { REQUIREMENT_INVENTORY_NAME } = MODULE_NAME;
const { DISCLAIMER } = AI_SIMULATION_GENAI_DISCLAIMER;
const { OBLIGATION } = ENTITY_TYPE;
const { MAPPING_ASSESSMENT } = PROGRESS_BAR_ELEMENTS;
const { regulationInventory, overView } = rrcpDashboardRoutes;

const { PENDING_REVIEW } = ENTITY_STATUS;

interface IMappingDetailProps {
	storageWrapper: any;
}

const MappingDetail = (props: IMappingDetailProps) => {
	const { storageWrapper } = props;
	const { groupId } = useParams();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();

	const { tableQueryObj, updateTableQuery } = useTableQuery({
		id: 'regInvRelationshipCard',
	});

	const loggedInUser: any = useSelector(
		(state: RootState) => state.common.loggedInUser,
	);

	const sideDrawerState = useSelector(
		(state: RootState) => state.common.mappingDrawer,
	);

	const [mappingAPIResponseData, setMappingAPIResponseData] = useState<
		IBusinessUnitMappingEntity[]
	>([]);
	const [citationGroupBusinessUnitIds, setCitationGroupBusinessUnitIds] =
		useState<string[]>([]);
	const [loading, setIsLoading] = useState<boolean>(false);
	const [mappingExpanded, setMappingExpanded] = useState<boolean>(false);
	const [searchText, setSearchText] = useState<string>('');
	const [showRegenerateDailogue, setShowRegenerateDailogue] =
		useState<boolean>(false);
	const [sideDrawerOpen, setIsSideDrawerOpen] = useState<boolean>(false);
	const [relationShipLoading, setRelationShipLoading] =
		useState<boolean>(false);
	const [sortOrder, setSortOrder] = useState<string>('asc');
	const [summaryData, setSummaryData] = useState<string>('');
	const [relationshipData, setRelationshipData] = useState<IMappingEnity[]>([]);
	const [releationshipDataCount, setRelationshipDataCount] =
		useState<number>(0);
	const [addStatusCardsCount, setAddStatusCardCount] = useState<number>(-1);
	const [reviewedStatusCardCount, setReviewedStatusCardCount] =
		useState<number>(-1);
	const [currentPageNumber, setCurrentPageNumber] = useState<number>(0);

	const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
	const [isAddingRelationMapping, setIsAddingRelationMapping] =
		useState<boolean>(false);
	const [isAllEntityDataLoading, setIsAllEntityDataLoading] =
		useState<boolean>(true);

	const isAICardsRegenerated = useSelector(
		(state: RootState) => state.regulationInventory.regInvAISummaryRegenerated,
	);

	const riskRefTaxonomySourceFiltersKey = useSelector(
		(state: RootState) => state.taxonomy.riskRefTaxonomySourceFiltersKey,
	);

	useEffect(() => {
		if (location.state && location.state.isMappingDrawerOpen) {
			setIsSideDrawerOpen(true);
		}
		makeGetApis();
	}, [groupId, sideDrawerState]);

	const getRelationshipData = async (
		pageNumber?: number,
		text?: string,
		order?: string,
	) => {
		const paramsData: IGetRegInvRelationshipRequestParams = {
			citationGroupId: '',
			pageNumber: 0,
			pageSize: 0,
			searchText: '',
			sortOrder: '',
			sortParam: '',
		};
		paramsData.citationGroupId = groupId || '';
		paramsData.searchText = text || '';
		paramsData.pageSize = 12;
		paramsData.pageNumber = pageNumber || 0;
		paramsData.sortOrder = order || sortOrder;
		paramsData.sortParam = 'childName';
		const response: any = await getRegInvRelationshipData(paramsData);
		if (response?.statusCode === OK && response.responseBody) {
			const tempTableData = response?.responseBody?.content;
			if (response?.responseBody.content.length === 0) {
				navigateToFirstPageIfCardsNotExists();
			}
			setRelationshipData(tempTableData);
			setRelationshipDataCount(response?.responseBody.totalCount);
		}
	};

	const modalBoxProps = {
		width: '30%',
		height: '30%',
		margin: 'top',
	};

	const getCardStatusCount = async () => {
		const response: any = await getMappingStatusCount(groupId || '');
		if (response?.statusCode === OK && response.responseBody) {
			setAddStatusCardCount(response.responseBody.addStatusCount);
			setReviewedStatusCardCount(response.responseBody.reviewedStatusCount);
		}
	};

	const makeGetApis = () => {
		if (groupId) {
			getMappingDetails(groupId);
			getRelationshipData(currentPageNumber, searchText, sortOrder);
			getCardStatusCount();
		}
	};

	const getMappingDetails = async (groupId: string) => {
		setIsLoading(true);
		const resp = await getMappingDetailsData(groupId);
		if (resp?.statusCode === OK && resp.responseBody) {
			setMappingAPIResponseData(resp.responseBody);
			resp.responseBody.forEach((res) => {
				if (res.assignedUserId === loggedInUser?.userId) {
					setCitationGroupBusinessUnitIds((prev) => [
						...prev,
						res.businessUnitGroupId,
					]);
				}
			});
		}
		setIsLoading(false);
	};

	const searchvalueRef = useRef<any>(null);

	const onAddBtnClickHandler = async (selectedOptions: any) => {
		setIsAddingRelationMapping(true);
		const filteredArray: IBusinessUnitMappingEntity[] =
			mappingAPIResponseData?.filter(
				(res) => res?.assignedUserId === loggedInUser?.userId,
			);
		const postAPIResponse = Promise.all(
			filteredArray?.map(async (res) => {
				const payloadArray: any[] = [];

				selectedOptions?.map((option: any) => {
					const data = {
						parentObjectId: res?.businessUnitGroupId,
						parentObjectType: 'CitationGroupBusinessUnit',
						generateMode: 'Manual',
						impactObjectId: option?.id,
						impactObjectType: option?.entityType,
						loggedInUser: loggedInUser?.userId,
						reviewStatus: PENDING_REVIEW,
					};
					payloadArray?.push(data);
					return payloadArray;
				});
				let statusCode: any = '';
				const response = await addRelationshipMapping(payloadArray);
				fetchToastMsgData(response, dispatch);
				setIsAddingRelationMapping(false);
				modalCloseHandler();
				fetchAllTabsData(
					OBLIGATION,
					riskRefTaxonomySourceFiltersKey,
					setIsAllEntityDataLoading,
					dispatch,
					groupId,
				);
				if (response.statusCode) {
					statusCode = response.statusCode;
				}
				return statusCode;
			}),
		);
		if ((await postAPIResponse).every((res) => res)) {
			makeGetApis();
		}
	};

	const updateMappingTaskStatus = async (
		values: IRegulationInventoryMappingElements,
	) => {
		let navigateFlag = false;
		if (values.actionType === STATUS_UPDATE_TYPE.REVIEW) {
			const BUMapping = mappingAPIResponseData.map((ele) => {
				if (ele.assignedUserId === loggedInUser?.userId) {
					return {
						...ele,
						mappingAssessment: {
							...ele.mappingAssessment,
						},
						...values,
						taskType: WORKFLOW,
						moduleName: REQUIREMENT_INVENTORY_NAME,
					};
				}
				return ele;
			});
			navigateFlag = await updateMappingStatus(BUMapping);
		} else {
			navigateFlag = await approveRejectMappingStatus(values);
		}
		if (navigateFlag) {
			navigate(urlWithTenant(`/${regulationInventory}/${overView}`));
		}
	};

	/**
	 * @description method to trigger add mapping button is clicked
	 */
	const addMappingClickHandler = () => {
		setIsModalOpen(true);
	};

	/**
	 * @description method to close the add mapping modal
	 */
	const modalCloseHandler = () => {
		setIsModalOpen(false);
		getRelationshipData(currentPageNumber, searchText, sortOrder);
	};

	const approveRejectMappingStatus = async (
		values: IRegulationInventoryMappingElements,
	) => {
		const businessUnitData = mappingAPIResponseData.map((ele) => ({
			assignedUserId: ele.assignedUserId,
			businessUnitId: ele.businessUnitId,
			businessUnitName: ele.businessUnitName,
			assignedUserName: ele?.assignedUserName,
			taskType: WORKFLOW,
			moduleName: REQUIREMENT_INVENTORY_NAME,
		}));
		const putPayloadData: IUpdateBusinessUnitMappingEntity = {
			...values,
			data: businessUnitData,
		};
		const resp: any = await putInventoryMappingStatus(
			putPayloadData,
			groupId || '',
		);
		return displayMessage(resp);
	};

	const updateMappingStatus = async (data: IBusinessUnitMappingEntity[]) => {
		setIsLoading(true);
		const resp: any = await postInventoryMappingStatus(data, groupId || '');
		return displayMessageSubmit(resp);
	};

	const sucessTostMessage = (resp: any) => {
		if (resp?.statusCode === OK || resp?.statusCode === CREATED) {
			dispatch(
				setToastMessage({
					message: 'The details saved successfully',
					severity: 'success',
					isToastOpen: true,
				}),
			);
			return true;
		}
		return false;
	};

	const postGenerate = async () => {
		if (groupId && summaryData) {
			const postData = {
				parentObjectId: groupId,
				text: removeHTMLTags(summaryData),
				type: '',
			};
			setRelationShipLoading(true);
			const resp = await postMappingGenerate(postData);
			if (resp.statusCode === OK) {
				dispatch(setRegInvSummaryRegenerated(true));
				makeGetApis();
			} else if (resp?.statusCode === INTERNAL_SERVER_ERROR) {
				setIsLoading(false);
				dispatch(
					setToastMessage({
						message:
							'Oops! It looks like there was an error with the AI. We apologize for the inconvenience. Please try again later.',
						severity: 'error',
						isToastOpen: true,
					}),
				);
			} else {
				const toastMessageConfig = generateToastMessage(resp);
				if (toastMessageConfig) {
					dispatch(
						setToastMessage({
							message: toastMessageConfig.message,
							isToastOpen: true,
							severity: toastMessageConfig.severity,
						}),
					);
				}
			}

			setRelationShipLoading(false);
		}
	};

	const displayMessage = (resp: any) => {
		sucessTostMessage(resp);
		if (resp?.errorBody || resp?.error) {
			dispatch(
				setToastMessage({
					message: REG_INV_APPROVAL_ERROR_MSG,
					severity: 'error',
					isToastOpen: true,
				}),
			);
			return false;
		}
		return true;
	};

	const handleSummaryValue = (data: any) => {
		setSummaryData(data);
	};

	const displayMessageSubmit = (resp: any) => {
		sucessTostMessage(resp);
		setIsLoading(false);
		if (resp?.errorBody || resp?.error) {
			dispatch(
				setToastMessage({
					message: REG_INV_SUBMIT_ERROR_MSG,
					severity: 'error',
					isToastOpen: true,
				}),
			);
			return false;
		}
		return true;
	};

	const style = {
		'& .MuiOutlinedInput-root': {
			'& fieldset': {
				border: `1px solid ${borderColor}`,
				borderRadius: '5px',
			},

			'&.Mui-focused fieldset': {
				border: `1px solid ${borderColor}`,
				borderRadius: '5px',
			},

			'&.MuiAccordionSummary-root:hover:not': {
				backgroundColor: `${searchBoxColor}`,
			},
		},
	};

	const onKeyDown = (e: any) => {
		e.stopPropagation();
	};

	const handleClearText = () => {
		if (searchvalueRef?.current) {
			searchvalueRef.current.value = '';
			setSearchText('');
			getRelationshipData(currentPageNumber, '', sortOrder);
		}
	};

	const textFieldValueChanged = (event: any) => {
		setSearchText(event.target.value);
		const pageObj = {
			pageSize: TABLE_SIZE_12,
			pageNumber: 0,
		};
		updateTableQuery(pageObj);
		setCurrentPageNumber(0);
		getRelationshipData(0, event.target.value, sortOrder);
	};

	const regenerateButtonClicked = () => {
		setShowRegenerateDailogue(true);
	};

	const regenerateDailogueCancelClicked = () => {
		setShowRegenerateDailogue(false);
	};

	const regenerateDailogueConfirmClicked = () => {
		postGenerate();
		setShowRegenerateDailogue(false);
	};

	const handlePageChange = (data: any) => {
		setCurrentPageNumber(data.pageNumber);
		getRelationshipData(data.pageNumber, searchText, sortOrder);
	};

	const sortButtonClicked = () => {
		if (sortOrder === 'asc') {
			setSortOrder('desc');
		} else if (sortOrder === 'desc') {
			setSortOrder('asc');
		}
		getRelationshipData(
			currentPageNumber,
			searchText,
			sortOrder === 'asc' ? 'desc' : 'asc',
		);
	};

	const isAllowedToAdd = () => {
		if (mappingAPIResponseData.length) {
			return mappingAPIResponseData.some(
				(ele) =>
					ele.assignedUserId === loggedInUser?.userId &&
					ele.taskStatus === PROGRESS_BAR_ELEMENTS.MAPPING_ASSESSMENT,
			);
		}
		return false;
	};

	const isAllowedToGiveFeedback = () => {
		if (mappingAPIResponseData.length) {
			return mappingAPIResponseData.some(
				(ele) => ele.assignedUserId === loggedInUser?.userId,
			);
		}
		return false;
	};

	const navigateToFirstPageIfCardsNotExists = () => {
		if (currentPageNumber - 1 < 0) {
			return;
		}
		const pageObj = {
			pageSize: TABLE_SIZE_12,
			pageNumber: 0,
		};
		updateTableQuery(pageObj);
		setCurrentPageNumber(0);
		getRelationshipData(0, searchText, sortOrder);
	};

	const shouldDisableFeedback = mappingAPIResponseData
		.filter((res) => res.assignedUserId === loggedInUser?.userId)
		.every((res) => res.taskStatus !== MAPPING_ASSESSMENT);

	const shouldHideDisclaimer =
		relationshipData.filter((res) => res.generateMode === 'AI').length === 0;

	useEffect(() => {
		fetchAllTabsData(
			OBLIGATION,
			riskRefTaxonomySourceFiltersKey,
			setIsAllEntityDataLoading,
			dispatch,
			groupId,
		);
	}, []);

	return (
		<RegInventorySummaryAndMapping
			handleSummaryValue={handleSummaryValue}
			submitHandlerForMapping={updateMappingTaskStatus}
			mappingData={mappingAPIResponseData || []}
			shouldEnableSubmitForReviewForMapping={
				addStatusCardsCount === 0 && reviewedStatusCardCount > 0
			}
			storageWrapper={storageWrapper}
		>
			<AccordionComp
				isLeftAccordian
				isFocusVisible
				className={styles['mapping-accordion']}
				expanded
				dataTestId="accordian-mapping-comp"
				onChange={() => setMappingExpanded(!mappingExpanded)}
				summary={
					<Grid container alignItems="center" justifyContent="space-between">
						<Grid item display="flex" alignItems="center">
							<Typography
								className={styles['mapping-accordian-text-header']}
								data-testid="mapping-test-id"
							>
								{toSentenceCase('Relationship Mapping')}
							</Typography>
						</Grid>
						<Grid
							item
							display="flex"
							alignItems="flex-end"
							gap="10px"
							className={styles['button-grid']}
						>
							<ButtonComp
								btnType="secondary"
								compClass={styles['regenerate-button']}
								startIcon={
									<Box className={styles['regenerate-button-icon']}>
										<Regenerate />
									</Box>
								}
								clickHandler={regenerateButtonClicked}
								data-testid="regenerate-button"
								disabled={relationShipLoading || !isAllowedToAdd()}
							>
								Regenerate
							</ButtonComp>
							<div className={styles['add-new-dropdown-wrapper']}>
								<ButtonComp
									btnType="secondary"
									startIcon={<Plus fill={addNewButtonColor} />}
									onClick={addMappingClickHandler}
									disabled={!isAllowedToAdd()}
									data-testid="add-mapping-btn"
									compClass={styles['btn-add-mapping']}
								>
									{toSentenceCase('Add Mapping')}
								</ButtonComp>
							</div>
							<TextField
								size="small"
								inputRef={searchvalueRef}
								className={styles['text-field']}
								autoFocus
								placeholder="Search"
								fullWidth
								onChange={textFieldValueChanged}
								onKeyDown={onKeyDown}
								InputProps={{
									inputProps: { 'data-testid': 'search-field' },
									startAdornment: (
										<InputAdornment position="start">
											<SearchOutlined className={styles['input-search-icon']} />
										</InputAdornment>
									),
									endAdornment: searchText && (
										<InputAdornment position="end">
											<button
												type="button"
												tabIndex={0}
												onClick={handleClearText}
												onKeyDown={handleClearText}
												className={styles['cursor-pointer']}
												aria-label="Clear"
												data-testid="circle-close-icon"
											>
												<img src={circleDeleteWhiteIcon} alt="circle-icon" />
											</button>
										</InputAdornment>
									),
								}}
								sx={style}
							/>
							<Card
								className={styles['sort-button']}
								onClick={sortButtonClicked}
								data-testid="sort-button"
							>
								<Box>
									<Sort />
								</Box>
							</Card>
							{isModalOpen && (
								<AddMappingModal
									isModalOpen={isModalOpen}
									modalCloseHandler={modalCloseHandler}
									parentEntityType={OBLIGATION}
									childEntityOptionsData={getChildEntityOptionsData(OBLIGATION)}
									onAddBtnClickHandler={(selectedOptions: any) =>
										onAddBtnClickHandler(selectedOptions)
									}
									moduleType={REQUIREMENT_INVENTORY_NAME}
									isAddingRelationMapping={isAddingRelationMapping}
									isAllEntityDataLoading={isAllEntityDataLoading}
								/>
							)}
							<ModalEle
								open={showRegenerateDailogue}
								sxBoxProps={modalBoxProps}
							>
								<RegenerateSummaryDailog
									cancelClicked={regenerateDailogueCancelClicked}
									submitClicked={regenerateDailogueConfirmClicked}
								/>
							</ModalEle>
							{sideDrawerOpen && (
								<div>
									<SideDrawer
										className={styles['side-drawer']}
										drawerState={sideDrawerState}
									>
										<DetailedMappingLayout
											moduleType={REQUIREMENT_INVENTORY}
											isDeleteEnabled={isAllowedToAdd()}
										/>
									</SideDrawer>
								</div>
							)}
						</Grid>
					</Grid>
				}
				details={
					loading ? (
						<Loader show={loading} />
					) : (
						<>
							{!relationShipLoading && (
								<CardTable
									id="regInvRelationshipCard"
									handlePagination={handlePageChange}
									render={(rowData) => (
										<AIMappingCard
											cardData={rowData}
											sideDrawerHandler={() => setIsSideDrawerOpen(true)}
											citationGroupBusinessUnitIds={Array.from(
												new Set(citationGroupBusinessUnitIds),
											)}
										/>
									)}
									rows={relationshipData}
									totalItems={releationshipDataCount}
									defaultQuery={tableQueryObj}
								/>
							)}
							{relationShipLoading && (
								<Grid container>
									<Grid
										item
										display="flex"
										gap="10px"
										className={styles['summary-loader-grid']}
									>
										<AILoader />
										<Typography className={styles['summary-loader-text']}>
											{PROCESSING}
										</Typography>
									</Grid>
								</Grid>
							)}
							{relationshipData.length === 0 && !relationShipLoading && (
								<Grid container>
									<Grid
										item
										display="flex"
										gap="10px"
										className={styles['summary-loader-grid']}
									>
										<Typography className={styles['summary-loader-text']}>
											{searchText ? NO_DATA_SEARCH : NO_DATA}
										</Typography>
									</Grid>
								</Grid>
							)}

							{!shouldHideDisclaimer && (
								<Grid container direction="row" alignItems="center">
									<Typography className={styles['disclaimer-text']}>
										{DISCLAIMER}
									</Typography>
									{isAllowedToGiveFeedback() && (
										<div className={styles['chat-feedback-grid']}>
											<AIFeedback
												objectType={RELATIONSHIP_MAPPING}
												module={REQUIREMENT_INVENTORY}
												objectData={{
													prompt: removeHTMLTags(summaryData),
													response: relationshipData,
													reference: `${groupId}${loggedInUser?.userId}`,
												}}
												isDisabled={shouldDisableFeedback}
												shouldResetFeedback={isAICardsRegenerated}
											/>
										</div>
									)}
								</Grid>
							)}
						</>
					)
				}
			/>
		</RegInventorySummaryAndMapping>
	);
};
export default MappingDetail;
